/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_CARAVAN = 42;

Mission.REGISTRATIONS.set(Mission.TYPE_CARAVAN, () => ({
    ...BaseMissionData(),
    available: cleverapps.config.availables.CARAVAN_MISSION,
    logic: Caravan,
    name: "Caravan",
    ship: "caravanship",
    duration: "3 day",
    semaphore: Mission.SEMAPHORE_SECONDARY,
    bundle: "unitssale",
    startWindow: CaravanMissionWindow,
    view: CaravanMissionWindow,
    unitStory: {
        unit: {
            code: "caravanship",
            stage: 0
        },
        delay: 2000
    },
    finishWindow: CaravanMissionWindow,
    sideBarJson: false,
    extraBarIcon: bundles.extrabar && {
        json: bundles.extrabar.jsons.caravan_extrabar_icon,
        background: bundles.extrabar.frames.extrabar_icon_bg_blue
    },
    teaser: false
}));
